export default function(values) {
  return {
    id: values.id,
    body: values.body,
    body_formatted: values.body_formatted,
    created: values.created,
    note_id: values.note_id,
  };
}
